export default __webpack_public_path__ + "static/media/welcome_bg.ade13aa6.png";